<div
  style="display: inline-block;"
  class="leaderboard-info-content"
  [ngClass]="{
    'leaderboard-silver': !strictRulesActive,
    'leaderboard-gold': strictRulesActive,
  }"
  [tooltip]="(tooltip() | translate) + ' ' + ('PUZZLE.leaderboard_info.tooltip_click' | translate)"
  placement="bottom"
>
  <div class="leaderboard-centered" (click)="showLeaderboardInfoModal($event)">
    {{ isFinished && withinLeaderboardSubmissionTime ? '★ ★' : '☆ ☆' }}
    {{ isSubmitted && withinLeaderboardSubmissionTime ? '★' : '☆' }}
  </div>
</div>
